  import {
    Container,
    IconButton,
    TextField,
    Typography,
    makeStyles,
  } from "@material-ui/core";
  import {
    FilterItems,
    FilterSelectionButton,
    KeyboardDatePickerInput,
    PrimaryButton,
    PrimaryTextButton,
  } from "../components-atoms";
  import { ITheme, theme } from "../constants/theme";
  import React, { ReactNode, useEffect, useRef, useState } from "react";
  import moment from "moment";
  import { getShortDateFormat } from "../utils/dateTimeFormatting";
  import Button from "@material-ui/core/Button";
  import CloseRounded from "@material-ui/icons/CloseRounded";
  import DateFnsUtils from "@date-io/date-fns";
  import { FilterList } from "@material-ui/icons";
  import { IPromotionCodeFilter } from "../redux/actions/promotionCodes";
  import Menu from "@material-ui/core/Menu";
  import { MuiPickersUtilsProvider } from "@material-ui/pickers";
  import { TabPanel } from "../components-molecules";
  import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
  import BackButton from "../components-atoms/BackButton";
import { buttonHoverAndActive, textButtonHoverAndActive } from "../utils/styles/buttonStyles";
import { useTranslation } from 'react-i18next';

  interface IFilterItem {
    title: string;
    value: string | boolean;
  }
  export interface IFilterOption {
    [key: string]: IFilterItem[];
  }
  export interface IFilter {
    [key: string]: Array<string | boolean | MaterialUiPickersDate> | undefined;
  }
  interface IProps {
    onSubmit: (thisFilter: IFilter | IPromotionCodeFilter) => void;
    inButtonSet: boolean;
    options: IFilterOption;
    filter: IFilter | IPromotionCodeFilter;
    defaultOption: string;
    dateKey?: string;
    searchableList?: string[];
    singleDate?: boolean;
  }

  const formatDateForFilter = (d: string) => {
    return moment(d).format(getShortDateFormat());
  };

  export const FilterButton = ({
    onSubmit,
    inButtonSet,
    options,
    filter,
    defaultOption,
    dateKey,
    searchableList = [],
    singleDate,
  }: IProps) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const searchInputRef = useRef<any>();
    const [thisFilter, setThisFilter] = useState<IFilter | IPromotionCodeFilter>(
      filter
    );
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [selectedOption, setSelectedOption] = useState<string>(defaultOption);
    const [submittedFilter, setSubmittedFilter] = useState({});
    const [optionsCopy, setOptionsCopy] = useState(options);
    const [dateOptions, setDateOptions] = useState({});
    const [index, setIndex] = useState(0);
    const [dateError, setDateError] = useState<ReactNode>();
    const [filterSearch, setFilterSearch] = useState<string>("");
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = (): void => {
      setIndex(0);
      setAnchorEl(null);
    };
    const filterButtonClicked = (option: string): void => {
      setSelectedOption(option);
      setIndex(1);
    };
    const onItemChange = (checked: boolean, value: string | boolean): void => {
      if (checked) {
        const tempItem = thisFilter[selectedOption] || [];
        setThisFilter({ ...thisFilter, [selectedOption]: [...tempItem, value] });
      } else {
        const tempSelectedOption = thisFilter[selectedOption]?.filter(
          (f) => f !== value
        );
        setThisFilter({ ...thisFilter, [selectedOption]: tempSelectedOption });
      }
    };
    const isFilterEmpty = (): boolean => {
      let result: boolean = true;
      if (index === 1) {
        return thisFilter[selectedOption]?.length === 0;
      }
      Object.keys(thisFilter).forEach((key) => {
        const tempItem = thisFilter[key] || [];
        if (tempItem.length > 0) {
          result = false;
        }
      });

      return result;
    };
    const getActiveFilterCount = (): number =>
      Object.keys(submittedFilter).filter(
        (key: string) => submittedFilter[key].length > 0
      ).length;
    useEffect(() => {
      setOptionsCopy(options);
    }, [options]);
    const clearFilter = (): void => {
      if (index === 1) {
        setThisFilter({ ...thisFilter, [selectedOption]: [] });
      } else {
        let tempFilter = {};
        Object.keys(thisFilter).forEach((key) => {
          tempFilter = { ...tempFilter, [key]: [] };
        });
        setThisFilter(tempFilter);
      }
      setDateOptions({});
      setFilterSearch("");
    };
    const selectAll = (): void => {
      const tempSelectedOptions = options[selectedOption].map(
        (filterItem: IFilterItem) => filterItem.value
      );
      setThisFilter({ ...thisFilter, [selectedOption]: tempSelectedOptions });
    };
    const isValid = (): boolean => {
      if (singleDate) {
        return !dateError;
      } else {
        return !(
          !!dateError ||
          thisFilter["Date"].length === 1 ||
          (thisFilter["Date"].length === 2 && !thisFilter["Date"][0])
        );
      }
    };

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div>
          <Button
            id="filter-button"
            data-automation="filter-button"
            aria-label="Filter"
            aria-controls={open ? "filter-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            startIcon={<FilterList color="primary" />}
            onClick={handleClick}
            style={{
              marginLeft: inButtonSet ? "8px" : undefined,
              backgroundColor: open
                ? theme.palette.secondary.main
                : getActiveFilterCount()
                ? theme.palette.secondary[24]
                : undefined,
            }}
            className={classes.textButton}
          >
            <Typography
              variant="button"
              component="span"
              color="primary"
              className={classes.printButtonText}
            >
              {t('common.filter')}{!!getActiveFilterCount() && ` · ${getActiveFilterCount()}`}
            </Typography>
          </Button>

          <Menu
            id="filter-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{ className: classes.menuPaper }}
            MenuListProps={{
              "aria-labelledby": "filter-button",
              role: "listbox",
              className: classes.menuList,
            }}
            className={classes.menu}
          >
            <Container
              onFocusCapture={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (searchInputRef && searchInputRef.current) {
                  searchInputRef.current.focus();
                }
              }}
              className={classes.titleContainer}
            >
              {index === 1 && (
                <BackButton
                  onClick={() => setIndex(0)}
                 
                />
              )}
              <Typography
                variant="h6"
                component="span"
                color="textPrimary"
                style={{ marginLeft: index === 1 ? 16 : 8 }}
              >
                {index === 0
                  ? t('common.filter')
                  : selectedOption === "Date"
                  ? t('common.orderDate')
                  : selectedOption}
              </Typography>
            </Container>
            <Container className={classes.buttonContainer}>
              {index === 1 && selectedOption !== "Date" && (
                <PrimaryTextButton
                  id="basic-button"
                  aria-controls="basic-menu"
                  aria-haspopup="true"
                  title={t('common.selectAll')}
                  onClick={() => selectAll()}
                  style={{ padding: "6px 12px" }}
                />
              )}
              <PrimaryTextButton
                id="basic-button"
                aria-controls="basic-menu"
                aria-haspopup="true"
                title={t('common.clearAll')}
                disabled={isFilterEmpty()}
                onClick={() => clearFilter()}
                style={{ padding: "6px 12px" }}
              />
            </Container>

            <TabPanel value={index} index={0}>
              <Container className={classes.tabContainer}>
                {Object.keys(options).map((optionKey) => {
                  const tempItem = thisFilter[optionKey] || [];
                  return (
                    <FilterSelectionButton
                      key={optionKey}
                      title={optionKey === "Date" ? t('common.orderDate') : optionKey}
                      onClick={() => filterButtonClicked(optionKey)}
                      selectedFilters={
                        optionKey === "Date"
                          ? thisFilter[optionKey].map((item: string) =>
                              item ? formatDateForFilter(item) : ""
                            )
                          : options[optionKey]
                              .filter((f) => tempItem.includes(f.value))
                              .map((item) => item.title)
                      }
                    />
                  );
                })}
              </Container>
            </TabPanel>
            <Container
              className={classes.tabContainer}
              style={{ padding: "8px 16px" }}
            >
              <TabPanel style={{ paddingTop: 0 }} value={index} index={1}>
                {searchableList.includes(selectedOption) ? (
                  <TextField
                    size="small"
                    inputRef={searchInputRef}
                    className={classes.searchInput}
                    variant="outlined"
                    placeholder={t('common.search') + ` ${selectedOption}`}
                    label={t('common.search') + ` ${selectedOption}`}
                    value={filterSearch}
                    onChange={(e) => {
                      e.preventDefault();
                      setFilterSearch(e.target.value);
                      setOptionsCopy({
                        ...optionsCopy,
                        [selectedOption]: options[selectedOption].filter(
                          (item: IFilterItem) =>
                            item.title
                              .toLowerCase()
                              .includes(e.target.value.toLocaleLowerCase())
                        ),
                      });
                    }}
                    InputProps={{
                      endAdornment: filterSearch ? (
                        <IconButton
                          edge="end"
                          onClick={() => {
                            setFilterSearch("");
                            setOptionsCopy({
                              ...optionsCopy,
                              [selectedOption]: options[selectedOption],
                            });
                          }}
                          size="small"
                          className={classes.clearSearchIconButton}
                        >
                          <CloseRounded
                            className={classes.clearSearchIcon}
                            fontSize="small"
                          />
                        </IconButton>
                      ) : undefined,
                    }}
                  />
                ) : (
                  <></>
                )}
                {optionsCopy[selectedOption].length > 0 ? (
                  optionsCopy[selectedOption].map(
                    (filterItem: IFilterItem, idx: number) => {
                      const tempItem = thisFilter[selectedOption]
                        ? [...thisFilter[selectedOption]]
                        : [];
                      if (selectedOption === dateKey) {
                        return (
                          <KeyboardDatePickerInput
                          key={idx}
                          placeholder="DD/MM/YYYY"
                          label={filterItem.title}
                          onError={(e) => {
                            if (!e && dateError) {
                              setDateError(undefined);
                              return;
                            }
                            setDateError(e);
                          }}
                          minDate={
                            filterItem.title === "To"
                              ? dateOptions["From"]
                              : undefined
                          }
                          minDateMessage={t('common.endDateShouldBeAfterStartDate')}
                          maxDateMessage={t('common.pleaseSelectDatePriorTo2100')}
                          onChange={(d) => {
                            setDateOptions({
                              ...dateOptions,
                              [filterItem.title]: d,
                            });
                            if (filterItem.title === "To") {
                              tempItem[1] = d;
                            } else {
                              tempItem[0] = d;
                            }
                            setThisFilter({
                              ...thisFilter,
                              [selectedOption]: tempItem,
                            });
                          }}
                          value={
                            dateOptions[filterItem.title] || tempItem[idx]
                              ? new Date(tempItem[idx])
                              : null
                          }
                        />
                      );
                    }
                    return (
                      <FilterItems
                        checked={
                          tempItem.filter((f) => f === filterItem.value)
                            .length > 0
                        }
                        key={filterItem.title}
                        title={filterItem.title}
                        onChange={(checked: boolean) => {
                          onItemChange(checked, filterItem.value);
                        }}
                      />
                    );
                  }
                )
                ) : (
                  <Typography
                    variant="caption"
                    component="p"
                    color="inherit"
                    className={classes.noResultsText}
                  >
                    {t('common.noResults')}
                  </Typography>
                )}
              </TabPanel>
            </Container>
            <Container className={classes.bottomButtonContainer}>
              <PrimaryButton
                disabled={dateKey ? !isValid() : false}
                title={t('common.applyFilters')}
                style={{ width: "100%", height: 36 }}
                onClick={() => {
                  setSubmittedFilter(thisFilter);
                  onSubmit(thisFilter);
                  handleClose();
                }}
              />
            </Container>
          </Menu>
        </div>
      </MuiPickersUtilsProvider>
    );
  };

  const useStyles = makeStyles((theme: ITheme) => ({
    printButtonText: {
      textTransform: "none",
    },
    buttonText: {
      textTransform: "none",
    },
    buttonIcon: {
      width: 18,
      height: 18,
      marginRight: 8,
    },
    titleContainer: {
      minWidth: 320,
      padding: "8px 8px 16px 8px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    buttonContainer: {
      paddingLeft: 4,
    },
    bottomButtonContainer: {
      paddingLeft: 16,
      paddingRight: 16,
      paddingTop: 24,
      paddingBottom: 16,
    },
    tabContainer: {
      flex: 1,
      width: "100%",
      maxWidth: 320,
      paddingLeft: 4,
      paddingRight: 4,
      "overflow-y": "auto",
    },
    menuList: {
      height: 560,
      width: 320,
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
    },
    menu: {
      marginTop: 65,
      marginRight: 120,
      "& [class*=MuiPaper-rounded-]": {
        top: 79,
        borderRadius: 12,
      },
    },
    primaryButton: {
      width: "100%",
      borderRadius: 8,
      ...buttonHoverAndActive
    },
    textButton: {
      borderRadius: 8,
      ...textButtonHoverAndActive
    },
    searchInput: {
      width: "100%",
    },
    clearSearchIconButton: {
      paddingRight: 0,
    },
    clearSearchIcon: {
      color: theme.palette.text.secondary,
    },
    menuPaper: {
      borderRadius: 12,
    },
    noResultsText: {
      paddingTop: 8,
      color: theme.palette.text.secondary,
    },
  }));
